import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { types, actions } from '../reducers/organisations'
import { apolloClient } from '@fe/business/src/apollo'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

function * loadOrganisationsEffect () {
  try {
    const response = yield call([apolloClient, apolloClient.query], {
      query: gql`
        query GetOrganisations {
          orgs {
            id
            name
            clubs {
              id
              name
            }
          }
        }
      `,
      fetchPolicy: 'network-only'
    })
    return _.get('data.orgs', response)
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * loadOrganisationsFlow () {
  const orgs = yield call(loadOrganisationsEffect)

  if (_.get('error', orgs)) {
    yield put(actions.loadError(orgs))
  } else {
    yield put(actions.loadSuccess(_.keyBy('id', orgs)))
  }

  yield put(actions.loadRequestDone())
}

export default function * () {
  return yield all([
    takeLatest(types.LOAD_REQUEST, loadOrganisationsFlow)
  ])
}
